import { useState, useEffect } from 'react';
import { Button, Modal, Input, message } from 'antd';
import { isSupportAgent2, isSupportAgent3, isSupportLead, isSupportManager } from '../../../../helpers/genericHelper';
import FileBankruptcy from '../Actions/FileBankruptcy';
import API from '../../../../services/API';

export default function ProfileActions({
  data,
  userId,
  userBlockStatus,
  reloadData,
  userBlockLoadingStatus,
  openEditAccountModal,   
  forceLogout,
  saveAndBuildCredit,
  furnishingEvents
}) {
  
  const {
    isUserBankrupt,
    silaUserStatus,
    avaUserStatus
  } = userBlockStatus || {};

  const [block, setblock] = useState(null);
  const [blockReason, setblockReason] = useState(null);
  const [bloclModalVisible, setBlockModalVisible] = useState(false);
  const [userBlocked, setUserBlocked] = useState("");

  useEffect(() => {
    setUserBlocked(data.blockStatus === "BLOCKED");
  }, [data.blockStatus]);

  
  const blockHandler = (event) => {
    setblock(event);
    setBlockModalVisible(true);
  };

  const blockConfirmed = async () => {
    if (block === "block") {
      try {
        await API.blockUser(userId, blockReason);
        message.success("Successfully blocked account");
        setUserBlocked(true);
      } catch (error) {
        message.error("Unable to block account");
      } finally {
        setBlockModalVisible(false);
        reloadData();
      }
    } else if (block === "unblock") {
      try {
        await API.unBlockUser(userId, blockReason);
        message.success("Successfully unblocked account");
        setUserBlocked(false);
      } catch (error) {
        message.error("Unable to unblock account");
      } finally {
        setBlockModalVisible(false);
        reloadData();
      }
    }
  };

  const closeBlockModal = () => {
    setblockReason(null);
    setBlockModalVisible(false);
  };

  return (
    <div style={{ display: "flex", justifyContent: "flex-end", padding: 10 }}>
      {isSupportManager() && <Button
            style={{
              marginRight: "2%",
            }}
            onClick={(event) => window.confirm("Are you sure you want to force logout this user?") && forceLogout()}
            loading={userBlockLoadingStatus}
            type="primary" danger ghost>
            {'Force Logout'}
          </Button>}
      {
        isSupportAgent3()
        && <FileBankruptcy 
          furnishingEvents={furnishingEvents}
          userId={userId} saveAndBuildCredit={saveAndBuildCredit}
          isBankruptStatus={isUserBankrupt} 
          onStatusChange={reloadData}
          data={data}/>
      }
      {isSupportLead() && (
        avaUserStatus?.isBlocked ? (
          <Button
            style={{
              marginRight: "2%",
            }}
            onClick={(event) => blockHandler("unblock")}
            loading={userBlockLoadingStatus}
            disabled={isUserBankrupt}
            type="primary" danger ghost>
            {'Unblock'}
          </Button>
        ) : (
          <Button
            danger
            style={{ marginRight: "2%" }}
            loading={userBlockLoadingStatus}
            onClick={(event) => blockHandler("block")}
            disabled={isUserBankrupt}
            type="primary">
            {'Block'}
          </Button>
        )
      )}
      <Modal
        title={"Confirmation"}
        centered
        mask={true}
        maskClosable={true}
        destroyOnClose={true}
        okButtonProps={{
          disabled: !blockReason,
        }}
        closable={true}
        visible={bloclModalVisible}
        onOk={blockConfirmed}
        onCancel={closeBlockModal}
        className="confirm-modal"
      >
        <p>Please provide the reason?</p>
        <Input
          onChange={(e) => setblockReason(e.target.value)}
          placeholder={"Reason..."}
          value={blockReason}
        />
      </Modal>

      {isSupportAgent2() &&
        <Button
          type={"primary"}
          onClick={openEditAccountModal}>
          {'Edit Account'}
        </Button>
      }

    </div>
  )
}